import { Link } from "react-router-dom";
import ModalBase from "../modals/ModalBase";
import { clientKindLabel, clientStatusLabel } from "../../js/api/clientActivity";
import { portalPathForClient } from "../../js/api/clientAccess";

export default function ConfirmClientModal({ client, profileTo, isOpen, onClose }) {
  if (!client) return null;
  return (
    <ModalBase isOpen={isOpen} title="Confirm client" onClose={onClose} compact quiet>
      <p>You are now viewing:</p>
      <p>
        <strong>{client.name}</strong>
      </p>
      <p className="muted">Client ID: {client.client_code}</p>
      <p className="muted">
        Status: {clientKindLabel(client)} · {clientStatusLabel(client.status)}
      </p>
      <div className="btn-row">
        <Link className="primary-btn" to={portalPathForClient(client)}>
          Open Client Portal
        </Link>
        {profileTo ? (
          <Link className="ghost-btn" to={profileTo}>
            Open Client Profile
          </Link>
        ) : null}
        <button type="button" className="ghost-btn" onClick={onClose}>
          Cancel
        </button>
      </div>
    </ModalBase>
  );
}
